<template>
    <div id="specialist-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <!-- <invoices-suppliers
                :supplier_id="supplier_id"
                :role_id="role_id"
                :kind_consult="kind_consult"
                v-on:close="showModal=false">
            </invoices-suppliers> -->
            <upload-invoice
                :reg_id="supplier_id"
                :role_id="role_id"
                :type_invoice="1"
                :kind_consult="kind_consult"
                v-on:close="showModal=false">
            </upload-invoice>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="row scr-gap-15-0">
                    <div class="col-12 col-xl-6">
                        <b-pagination align="fill"
                                      v-model="pagination.current_page"
                                      :total-rows="pagination.total"
                                      :per-page="pagination.per_page"
                                      aria-controls="my-table"
                                      size="lg"
                                      v-on:change="onChange">

                        </b-pagination>
                    </div>
                    <div class="col col-xl-4">
                        <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                               placeholder="Buscar por palabra">
                        <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                    </div>
                    <div class="col-6 col-xl-2">
                        <select class="float" v-model="sinesterOfSpecialist.limit" v-on:change="changeLimit">
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <b-table sticky-header="100vh" stacked="md" id="my-table" striped hover :fields="fields"
                             :busy="isBusy" :items="pagination.data" :filter="filter">
                        <!-- A virtual column -->
                        <template #cell(paciente)="{item}">
                            <span>{{ item.id }}</span>
                        </template>
                        <template #cell(paciente)="{item}">
                            <span>{{ item.sku }}</span>
                        </template>
                        <template #cell(motivo)="{item}">
                            <span>{{ item.relreason.name }}</span>
                        </template>
                        <template #cell(lugar)="{item}">
                            <span>{{ item.relplace.name }}</span>
                        </template>

                        <template #cell(pdf)="{item}">
                        <span v-if="item.pdf">
                            <a class="fileName float" :href="'../storage/siniestro/'+item.pdf" target="_blank">
                                <i class="fas fa-file-pdf"></i>
                            </a>
                        </span>
                        </template>
                        <template #cell(acciones)="{item}">
                            <div class="dropdown">
                                <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-cogs"></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="modificar=true;">
                                        Cargar Factura
                                    </a>
                                </div>
                            </div>
                        </template>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {sinisterService} from "../../Services/Sinister.service";
import {supplierspecialistService} from "../../Services/SupplierSpecialist.service";
import {supplierinstitutionsService} from "../../Services/SupplierInstitutions.service";
import {rolesService} from "../../Services/Roles.service";
import {supplierambulancesService} from "../../Services/SupplierAmbulances.service";
import {supplierlaboratoriesService} from "../../Services/SupplierLaboratories.service";
import {supplierdentistsService} from "../../Services/SupplierDentists.service";
import {supplierradiologyService} from "../../Services/SupplierRadiologia.service";
import {supplieropticiansService} from "../../Services/SupplierOpticians.service";

export default {
    name: "consultation-component",
    mixins: [myMixins],
    props: {
        supplier_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        },
        kind_consult: {
            type: Number || null,
            required: false,
            default: 0
        },
    },
    data() {
        return {
            prov_role_id: 0,
            specialist_id: 0,
            inst_id: 0,
            modificar: false,
            isBusy: false,
            filter: null,
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            sinesterOfSpecialist: {
                limit: 10,
                search: '',
                page: 1,
                where: [{
                    field: 'supplier_id',
                    operator: '=',
                    value: this.supplier_id,
                }, {
                    field: 'role_id',
                    operator: '=',
                    value: this.role_id,
                }],
            },
            fields: [
                {key: 'id'},
                {key: 'paciente'},
                {key: 'motivo'},
                {key: 'lugar'},
                {key: 'pdf'},
                {key: 'acciones'},

            ],
            specialists: [],
            institutions: [],
            providers: [],
            list_providers: [],
        }
    },
    methods: {
        onChange(page) {
            //console.log('onchange');
            this.sinesterOfSpecialist.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        async index() {
            this.isBusy = true;
            this.pagination = await sinisterService.getMany(this.sinesterOfSpecialist);
            this.isBusy = false;
        },
    },
    mounted() {
        this.index();
    }
}
</script>

